"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=product-item-parameter.js.map